<div class="main-page-section default_font pt-3 pt-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-coupon">List Coupon</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev">Coupon Details</span>
        </div>

        <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <h2 class="font-weight-bold mb-3 mb-md-4">Coupon Details</h2>
            <h4 class="text-primary font-weight-semibold">Title: {{couponDetails?.data.couponTitle}}</h4>
        </div>

        <h6 class="font-weight-light h5 mb-3 mb-md-4">Coupon Attributes</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium ">Coupon Type</small>
                <span class="font-weight-medium text-gray-dark">{{couponDetails?.data.couponType}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Title</small>
                <span class="font-weight-medium text-gray-dark">{{couponDetails?.data.couponTitle}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Value in(₹)</small>
                <span class="font-weight-medium text-gray-dark">{{couponDetails?.data.couponValue}}/-</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Start Date</small>
                <span
                    class="font-weight-medium text-gray-dark">{{formatDateAll(couponDetails?.data.couponValidFrom,'date')}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">End Date</small>
                <span
                    class="font-weight-medium text-gray-dark">{{formatDateAll(couponDetails?.data.couponValidTo,'date')}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-2 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Coupon Count</small>
                <span class="font-weight-medium text-gray-dark">{{couponDetails?.data.couponCount}}</span>
            </div>
            <div class="col-12 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Coupon Details</small>
                <span class="font-weight-medium text-gray-dark">{{couponDetails?.data.couponDescription}}</span>
            </div>
            <div class="col-12 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Coupon Logo</small>
                <div class="coupon_image">
                    <img [src]="couponDetails?.data.couponLogo" [alt]="couponlogo" [title]="couponlogo">
                </div>
            </div>
        </div>
    </div>
    <div
        class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
        <button class="btn btn-primary" (click)="openModal(couponId, fromListPage)">Remove</button>
    </div>
</div>